module.exports = __webpack_public_path__ + "static/media/FOTO1.8d1ce9b4.jpg";